import { render, staticRenderFns } from "./project_avatar.vue.js?vue&type=template&id=749ad226&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_avatar.vue?vue&type=template&id=749ad226&vue3"
import script from "./project_avatar.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_avatar.vue?vue&type=script&lang=js&vue3"
export * from "./project_avatar.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_avatar.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports